export const enumToKeys = <T extends object = object>(enumObject: T) =>
  Object.keys(enumObject)
    .filter((key) => {
      // 숫자 0 은 false 이므로 별도 처리
      return Number(key) === 0 || !!Number(key);
    })
    .map((key) => (isNaN(Number(key)) ? key : Number(key)));

export const enumToValues = <T extends object = object>(enumObject: T) =>
  Object.values(enumObject).filter((value) => !Number(value));

export enum WorkStatusEnum {
  'READY' = 10,
  'COMPLETED' = 30,
  'REJECTED' = 40,
  'CANCELED' = 50,
}

export const TicketStatusColor = {
  10: '#22BCEC',
  40: '#FF9B05',
  30: '#4F64D7',
  50: '#FF2E2D',
};

export enum WorkStatusKoreanEnum {
  '작업대기' = 10,
  '작업완료' = 30,
  '재작업 요청' = 40,
  '작업취소' = 50,
}

export enum WeekDayEnum {
  '월',
  '화',
  '수',
  '목',
  '금',
  '토',
  '일',
}

export enum FullWeekDayEnum {
  'monday' = '월',
  'tuesday' = '화',
  'wednesday' = '수',
  'thursday' = '목',
  'friday' = '금',
  'saturday' = '토',
  'sunday' = '일',
}

// 2024-10-22 이전 버전
// export enum ContractTypeEnum {
//   '시급제' = 1, // 4대보험이 포함된 크루, was '파트타임'
//   '월급제', // 4대보험이 포함된 크루, was '풀타임'
//   '프리랜서', // 4대보험 지급하지않는 크루
//   '파트너', // 협력업체 또는 클리니어 위드, was '프리랜서'
// }
export enum ContractTypeEnum {
  '프리랜서(시급제)' = 1, // was '시급제'
  '프리랜서(월급제)', // was '월급제'
  '4대보험', // was '프리랜서'
  '위드', // was '파트너'
  '업체', // 신규 추가
}

export enum PayTypeEnum {
  '월급',
  '시급',
}

export enum GenderEnum {
  '남' = 1,
  '여',
}

export enum UserRoleCodeEnum {
  '시스템 관리자' = 'ROLE_SYSTEM',
  '총괄 매니저' = 'ROLE_SUPER_MANAGER',
  '매니저' = 'ROLE_MANAGER',
  '하도급 업체' = 'ROLE_SUBCONTRACTOR',
  '크루' = 'ROLE_CREW',
}

export enum ListQueryParamEnum {
  Page = 'page',
  Start = 'start',
  Size = 'size',
  Q = 'q',
  Search = 'search',
  ClientIds = 'clientIds',
  VenueIds = 'venueIds',
  ContractTypes = 'contractTypes',
  Genders = 'genders',
  ServiceIds = 'serviceIds',
  ServiceLabels = 'serviceLabels',
  Date = 'date',
  NeedAll = 'needAll',
}

export enum PeriodTypeEnum {
  /**
   * *매일* 또는 *매 N일마다* 반복되는 유형.
   */
  '매일' = 100,
  /**
   * *매주* 반복되는 유형.
   * 반복되는 요일이 지정되어야 하며, 요일의 복수 선택도 포함한다.
   */
  '매주' = 200,
  /**
   * *매 N주마다* 반복되는 유형.
   * 반복되는 요일이 지정되어야 하며, 요일의 복수 선택도 포함한다.
   * @important 서버에서는 200 이지만, 프론트단에서 구분하기위해 201 타입을 임시 지정해준다.
   */
  '격주' = 201,
  /**
   * *매달 **X**번째로 등장하는 **Y**요일*에 반복되는 유형.
   * **X**는 음수인 경우 그 달의 *뒤에서부터 **X**번째*로 생각한다. 예를 들어 **X**가 **-1**인 경우 그 달의 마지막 **Y**요일을 가리킨다.
   */
  '매달' = 301,
}

export enum GbCodeKoreanEnum {
  '지하' = 10,
  '지상' = 20,
  '복수층(하층)' = 21,
  '복수층(상층)' = 22,
  '옥상' = 30,
  '각층' = 40,
}

export const GbCodeKoreanMap = {
  10: '지하',
  20: '지상',
  21: '복수층(하층)',
  22: '복수층(상층)',
  30: '옥상',
  40: '각층',
};

export const AtNthComingOfDayOfWeek = {
  1: 1,
  2: 2,
  3: 3,
  4: 4,
  [-1]: '마지막',
};

export enum NoticeTypeEnum {
  CREW,
  CLEANIER,
}

export enum NoticeTargetEnum {
  Operator,
  // Clients,
  Venues,
}

/**
 * 업무 요청
 */
export enum RequestTypeKoreanEnum {
  'WORK' = '업무수정',
  'ETC' = '기타',
}

export enum RequestStatusKoreanEnum {
  '미응답' = 10,
  '승인' = 20,
  '거절' = 30,
}
